<template>
  <div>
    <vx-card title="Edit Location Support" class="mb-base">
      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full">
          <div class="label-text">
            Country (เลือกประเทศ)
          </div>
          <v-select
            class="inputx"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="vendorLocationModel.countryId"
            :options="country"
            label="countryName"
            :reduce="(country) => country.id"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full">
          <div class="label-text">
            Province (เลือกจังหวัด)
          </div>
          <v-select
            class="inputx"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="vendorLocationModel.provinceId"
            :options="province"
            label="provinceName"
            :reduce="(province) => province.id"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full mt-8">
          <vs-button @click="addVendorLocation">Add Location</vs-button>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full"></div>
      </div>
    </vx-card>

    <!-- Table -->
    <vx-card title="Edit Location Support" class="mb-base">
      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/1 sm:w-1/1 w-full">
          <vs-table
            search
            pagination
            max-items="5"
            :data="vendorLocationList"
            :stripe="true"
            v-if="vendorLocationList != null"
          >
            <template slot="thead">
              <vs-th sort-key="countryName">Country</vs-th>
              <vs-th sort-key="provinceName">Province</vs-th>
              <vs-th sort-key="delete">Action</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <!-- <vs-td :data="indextr">
                  {{ indextr }}
                </vs-td> -->
                <vs-td :data="data[indextr].countryName">
                  {{ data[indextr].countryName }}
                </vs-td>
                <vs-td :data="data[indextr].provinceName">
                  {{ data[indextr].provinceName }}
                </vs-td>
                <vs-td>
                  <feather-icon
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="ml-2"
                    @click.stop="deleteVendorLocation(tr.id)"
                  />
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <pre v-if="vendorLocationList == null">No data Available.</pre>
        </div>
      </div>
      <vs-divider />
      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/1 sm:w-3/4 w-full"></div>
        <div class="vx-col md:w-1/1 sm:w-1/4  w-full">
          <vs-button type="border" class="mb-2" @click="back">Close</vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";

// Services
import { _masterservices } from "../../../services/masterservices";
import { _vendorservice } from "../../../services/vendorservices";
export default {
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      // Option
      province: [],
      country: [],

      vendorLocationList: [],

      vendorLocationModel: {
        vendorId: 0,
        userName: this.propUserName,
        countryId: 0,
        provinceId: 0,
      },

      id: 0,
    };
  },
  async created() {
    await this.getCountry();
    await this.getProvince();

    this.getVendorLocation();
  },
  methods: {
    async getCountry() {
      this.country = await _masterservices.GetMasterCountry();
    },
    async getProvince() {
      this.province = await _masterservices.GetMasterProvince();
    },
    async getVendorLocation() {
      this.vendorLocationList = await _vendorservice.GetVendorLocation(
        this.$route.params.username,
        0
      );
    },
    async addVendorLocation() {
      if (this.vendorLocationModel.countryId != 0) {
        if (this.$route.params.username != "") {
          const model = {
            vendorId: parseInt(this.$route.params.id),
            userName: this.$route.params.username,
            countryId: this.vendorLocationModel.countryId,
            provinceId: this.vendorLocationModel.provinceId,
          };

          await _vendorservice.AddVendorLocation(model);
        } else {
          this.$vs.notify({
            title: "Can't add location!",
            text: "This vendor not found",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      } else {
        this.$vs.notify({
          title: "Can't add location!",
          text: "Please select country before",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }

      // Reload vendor location
      this.getVendorLocation();
    },
    deleteVendorLocation(id) {
      this.id = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm delete`,
        text: `Are you sure to delete this location?`,
        accept: this.acceptAlert,
      });
    },
    acceptAlert: async function() {
      let result = await _vendorservice.DeleteVendorLocation(this.id);
      if (result) {
        this.$vs.notify({
          title: "Delete location!",
          text: "Delete location success",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });

        // Reload vendor location
        this.getVendorLocation();
      }
    },
    back() {
      this.$router
        .push("/procurement-management/vendor/main/" + this.$route.params.id)
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.label-text {
  padding-bottom: 10px;
  color: #103a5d;
  font-weight: 500;
}
</style>
